import React, { useState } from "react";
import ServiceActivationModal from "../shared/service-activation/ServiceActivationModal";
import HideContentIcon from "../components/mini-app/shared/HideContentIcon";

function HiddenContent({ service, iconStyle = {}, className = "" }) {
  const [showActivationModal, setShowActivationModal] = useState(false);

  return (
    <>
      <HideContentIcon
        style={{ display: "inline-block", ...iconStyle }}
        className={className}
        clickHandler={() => setShowActivationModal(true)}
      />

      {showActivationModal && (
        <ServiceActivationModal
          service={service}
          show={showActivationModal}
          setShow={setShowActivationModal}
        />
      )}
    </>
  );
}

export default HiddenContent;
